module.exports = __webpack_public_path__ + "img/product-details-1.7d4c9f41.svg";